import { FC } from 'react'
import { useNavigate } from 'react-router-dom'
import { IconPaths } from '_metronic/helpers'
import { RowActions } from 'app/components'
import { UsuarioList } from 'app/modules/apps/admin/usuarios/usuarios-list/core/_models'

type Props = {
  usuario: UsuarioList
}

export const LogsUsuarioActionsCell: FC<Props> = ({ usuario }) => {
  const navigate = useNavigate()

  return (
    <RowActions
      itemName={usuario.nomeSocial || usuario.nome || 'usuário'}
      primaryAction={{
        label: 'Ver logs',
        icon: IconPaths.Search,
        onClick: () => navigate(`/apps/admin/logs/usuario/${usuario.id}`),
      }}
    />
  )
}
